"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_be402853{display:table-row}.resultContent_be402853 .resultItem_be402853{display:table-cell;vertical-align:bottom}.peoplePickerPersona_be402853{width:180px}.peoplePickerPersona_be402853 .ms-Persona-details{width:100%}.peoplePicker_be402853 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_be402853{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n" }]);
exports.resultContent = "resultContent_be402853";
exports.resultItem = "resultItem_be402853";
exports.peoplePickerPersona = "peoplePickerPersona_be402853";
exports.peoplePicker = "peoplePicker_be402853";
exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_be402853";
//# sourceMappingURL=PeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/pickers/PeoplePicker/PeoplePicker.scss.js
// module id = 842
// module chunks = 0